import { render, staticRenderFns } from "./c_media.vue?vue&type=template&id=54616717&scoped=true"
import script from "./c_media.vue?vue&type=script&lang=js"
export * from "./c_media.vue?vue&type=script&lang=js"
import style0 from "./c_media.vue?vue&type=style&index=0&id=54616717&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54616717",
  null
  
)

export default component.exports